import React, { useRef, useState } from 'react';
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import {useForm} from "react-hook-form";
import {connect} from "react-redux";
import {
    Button, Card, CardBody, CardTitle, Col, Form, FormGroup,
    Input, InputGroup, InputGroupAddon, Label, Row
} from 'reactstrap';


// components
import ServiceLocationLangs from "./_langs";
import SelectGeneric from "../../../components/select/selectGeneric";
import {ButtonCancel, ButtonSubmit, GenericTableButton} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {MapPickerModal} from "../../../components/map/MapPickerModal";

// labels
import {error, FORM, selectOption} from "../../../components/i18n/i18n";
import {TT_HISTORY} from "../../../components/i18n/toolTips";

// services & providers
import {routProvider} from "../../../providers/routProvider";
import {categoryProvider} from "../../../providers/categoryProvider";
import {typeServicesProvider} from "../../../providers/typeServicesProvider";

// actions
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/eventx/servicesLocationsActions";

// components
// labels
// actions
// services & providers


function ServiceLocationForm(props) {
    const { editMode, domainObject } = props.formProps;
    const { udn, mapConfig } = props.mainProps;
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    const [langs, setLangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []

    const [schedule24, setSchedule24] = useState(domainObject?.schedule24 || '');
    const [schedule12, setSchedule12] = useState(domainObject?.schedule12 || '');

    const [timeFrom, setTimeFrom] = useState('00:00');
    const [timeTo, setTimeTo] = useState('00:00');

    const requiredCategory = props.mainProps?.app?.code !== 'EVENTS'
    const requiredServiceType = props.mainProps?.app?.code !== 'EVENTS'

    const [status, setStatus] = useState(domainObject?.status || false);
    const [routeId, setRouteId] = useState( domainObject?.rout?.id || null);
    const [categoryId, setCategoryId] = useState( domainObject?.category?.id || null);
    const [typeServiceId, setTypeServiceId] = useState( domainObject?.services?.id || null);

    const [showModalHistory, setShowModalHistory] = useState(true)
    const [showMapModal, setShowMapModal] = useState(true);
    const modalHistoryRef = useRef(null);
    const modalMapRef = useRef(null);

    const [position, setPosition] = useState(editMode ? {
        lat: parseFloat(domainObject?.latitude),
        lng: parseFloat(domainObject?.longitude)
    } : mapConfig?.center);

    const showHistory = () => {
        setShowModalHistory(true);
        modalHistoryRef.current.showModal();
    }

    const showMap = () => {
        setShowMapModal(true);
        modalMapRef.current.showModal(mapConfig);
    }

    const validationSchema = Yup.object().shape({});

    const {register, handleSubmit, reset } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,

            latitude: domainObject?.latitude,
            longitude: domainObject?.longitude,
            schedule12: domainObject?.schedule12,
            schedule24: domainObject?.schedule24,
            photo: domainObject?.photo,
            anden: domainObject?.anden,
            color: domainObject?.color,
            departures: domainObject?.departures
        }
    });

    const setSchedule = (from, to) => {
        const fromh24 = from.split(':')[0];
        const fromm24 = from.split(':')[1];

        let toh24 = to.split(':')[0];
        let tom24 = to.split(':')[1];

        if (fromh24 > toh24 || (fromh24 === toh24 && fromm24 > tom24)) {
            to = from;

            toh24 = to.split(':')[0];
            tom24 = to.split(':')[1];
            setTimeTo(to);
        }

        let from12;
        let to12;

        if (fromh24 >= 12) {
            from12 = fromh24 === "12" ? `12:${fromm24} PM` : `${fromh24 - 12}:${fromm24} PM`;
        } else {
            from12 = `${fromh24}:${fromm24} AM`;
        }

        if (toh24 >= 12) {
            to12 = toh24 === "12" ? `12:${tom24} PM` : `${toh24 - 12}:${tom24} PM`;
        } else {
            to12 = `${toh24}:${tom24} AM`;
        }

        if (from === to) {
            setSchedule24(`${from}`);
            setSchedule12(`${from12}`);
        } else {
            setSchedule24(`${from} - ${to}`);
            setSchedule12(`${from12} - ${to12}`);
        }
    }

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const onTimeFromChange = (value) => {
        setTimeFrom(value);
        setSchedule(value, timeTo);
    }

    const onTimeToChange = (value) => {
        setTimeTo(value);
        setSchedule(timeFrom, value);
    }

    const onLatChange = (value ) => {
        setPosition({
            ...position,
            lat : value
        })
    }

    const onLngChange = ( value ) => {
        setPosition({
            ...position,
            lng : value
        })
    }

    // ----------------------------------------------
    //            SUBMIT
    // ----------------------------------------------

    const onSubmit = (data, _) => {
        if(requiredCategory && !categoryId)
            return showToastCustom(error, selectOption);

        if (requiredServiceType && !typeServiceId)
            return showToastCustom(error, selectOption);

        let dataRequest = {
            fbDataBase :  { id : fbDataBaseId },
            item : {
                id: domainObject?.id,
                uid: domainObject?.uid,
                latitude: position.lat,
                longitude: position.lng,
                schedule12: schedule12,
                schedule24: schedule24,
                photo: data?.photo,
                status: status,
                udn: udn,
                services : { id : typeServiceId },
                rout : { id : routeId },
                category : { id : categoryId },
                langs: langs,
                anden: data.anden,
                color: data.color,
                departures: data.departures
            }
        };

        try{
            if (editMode) {
                let id = domainObject.id;

                props.update(id, dataRequest)
            } else {
                props.save(dataRequest)
            }

            closeForm()
        } catch (error) {
            console.log(error)
        }
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose()
    }


    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                <div className="float-right">
                    {
                        editMode && <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    }
                </div>
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Tipo de Servicio</Label>
                                <SelectGeneric
                                    initialValue={ typeServiceId }
                                    setExternalValue={ setTypeServiceId }
                                    provider={ typeServicesProvider }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Ruta</Label>
                                <SelectGeneric
                                    initialValue={ routeId }
                                    setExternalValue={ setRouteId }
                                    provider={ routProvider }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Categoria</Label>
                                <SelectGeneric
                                    initialValue={ categoryId }
                                    setExternalValue={ setCategoryId }
                                    provider={ categoryProvider }
                                />
                            </FormGroup>
                        </Col>

                    </Row>
                    <Row>
                        <Col md="8">
                            <FormGroup>
                                <Label >Latitud y longitud</Label>
                                <InputGroup>
                                    <Button color=" background-color-primary" onClick={showMap}>
                                        <i className="fas fa-map-marker-alt text-white"/>
                                    </Button>
                                    <InputGroupAddon addonType="append">
                                        <Input type="number"
                                               name="lat"
                                               value={position?.lat}
                                               className={'lat-lng-input'}
                                               step={'0.0000001'}
                                               onChange={e => onLatChange(e.target.value)}
                                        />
                                    </InputGroupAddon>
                                    <InputGroupAddon addonType="append">
                                        <Input type="number"
                                               name="lng"
                                               className={'lat-lng-input'}
                                               value={ position?.lng}
                                               step={'0.0000001'}
                                               onChange={e => onLngChange(e.target.value)}
                                        />
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label >Nombre de imagen</Label>
                                <Input type="text"
                                       name="photo"
                                       placeholder="Ingrese nombre"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label >Activo</Label>
                                <br/>
                                <Switch animate={true}
                                        offText={"No"}
                                        onText={"Si"}
                                        value={status}
                                        onChange={_ => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="2">
                            <FormGroup>
                                <Label >Desde</Label>
                                <Input type="time"
                                       name="timeFrom"
                                       placeholder="Ingrese hora"
                                       innerRef={register}
                                       value={timeFrom}
                                       onChange={e => onTimeFromChange(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label >Hasta</Label>
                                <Input type="time" name="timeTo"
                                       placeholder="Ingrese hora"
                                       innerRef={register}
                                       value={timeTo}
                                       onChange={e => onTimeToChange(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="mdi mdi-book mr-2"/>
                        Información internacional
                    </CardTitle>

                    <CardBody>
                        <ServiceLocationLangs
                            langs={langs}
                            setLangs={setLangs}
                            translatableLangs={translatableLangs}
                        />
                    </CardBody>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
            {
                showMapModal &&
                <MapPickerModal
                    ref={modalMapRef}
                    setPosition={setPosition}
                    initialPosition={position}
                    googleConfig={mapConfig}
                    updateMarkerPosition={true}/>
            }
            {
                showModalHistory && <LogHistoryModal
                    ref={ modalHistoryRef }
                    item={ domainObject }
                />
            }
        </Card>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setItem,
    setForm,
    save,
    update,
})

export default connect(mapStateToProps, mapActionsToProps)(ServiceLocationForm)